import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from '../components/global-styles';
import bumeranPostulantes from './skins/bumeran-postulantes';
import zonajobs from './skins/zonajobs';
import zonajobsPostulantes from './skins/zonajobs-postulantes';
import bumeranEmpresas from './skins/bumeran-empresas';
export var themes = {
  bumeranPostulantes: bumeranPostulantes,
  bumeranEmpresas: bumeranEmpresas,
  zonajobs: zonajobs,
  zonajobsPostulantes: zonajobsPostulantes
};
export var PortalTheme = function PortalTheme(_ref) {
  var portal = _ref.portal,
      children = _ref.children;

  var _a;

  return React.createElement(ThemeProvider, {
    theme: (_a = themes[portal]) !== null && _a !== void 0 ? _a : bumeranPostulantes
  }, React.createElement(React.Fragment, null, React.createElement(GlobalStyles, null), children));
};